(function () {
  if (document.documentElement.dataset.waveRowsBound) return;
  document.documentElement.dataset.waveRowsBound = 'true';
  // Delegation survives filter updates and Shopify section replacement.
  document.addEventListener('click', function (event) {
    var button = event.target.closest('.per-row__button');
    if (!button) return;
    var section = button.closest('.shopify-section');
    if (!section) return;
    var value = button.dataset.perRow;
    var view = button.dataset.waveView;
    var collection = button.closest('.wave-nc-collection');
    if (view && collection) {
      collection.setAttribute('data-wave-' + view + '-columns', value);
      section.querySelectorAll('.per-row__button[data-wave-view="' + view + '"]').forEach(function (item) {
        var selected = item.dataset.perRow === value;
        item.classList.toggle('active', selected);
        item.setAttribute('aria-pressed', String(selected));
      });
      return;
    }
    // Preserve the original controls on non-collection templates.
    section.querySelectorAll('.per-row__button').forEach(function (item) {
      var selected = item.dataset.perRow === value;
      item.classList.toggle('active', selected);
      item.setAttribute('aria-pressed', String(selected));
    });
    section.querySelectorAll('[data-productis-in-row]').forEach(function (grid) {
      grid.setAttribute('data-productis-in-row', value);
    });
  });
})();
